import styled, { css } from 'styled-components';

export const Section = styled.section`
  position: relative;
  width: 100%;
`;

export const Gradient = styled.img`
  width: 100%;
  margin-bottom: -3px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 924px;
  padding: 0 24px;
`;

const text = css`
  text-align: center;
  color: #fff;
`;

export const Text = styled.h2`
  ${text}
`;

Text.xs = styled.h4`
  ${text}
`;
